/************************************************************
 * Primitive Definitions
 */
const __FONT_WEIGHT__ = {
  fw100: 100,
  fw200: 200,
  fw300: 300,
  fw400: 400,
  fw500: 500,
  fw600: 600,
  fw700: 700,
  fw800: 800,
  fw900: 900,
} as const

/************************************************************
 * Semantic Definitions
 */
const __SEMANTIC_FONT_WEIGHT__ = {
  regular: __FONT_WEIGHT__.fw400,
  medium: __FONT_WEIGHT__.fw500,
  semibold: __FONT_WEIGHT__.fw600,
  bold: __FONT_WEIGHT__.fw700,
} as const

/************************************************************
 * Export
 */
export const FONT_WEIGHT = Object.freeze({
  ...__FONT_WEIGHT__,
  ...__SEMANTIC_FONT_WEIGHT__,
})
